import { render } from "./appheader.vue?vue&type=template&id=5d913a7d&scoped=true"
import script from "./appheader.vue?vue&type=script&lang=js"
export * from "./appheader.vue?vue&type=script&lang=js"

import "./appheader.vue?vue&type=style&index=0&id=5d913a7d&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d913a7d"]])

export default __exports__